import type { RouteRecordRaw } from 'vue-router'

const baseRoutes: RouteRecordRaw = {
  path: '/base',
  name: 'Base',
  redirect: '/base/supplier',
  meta: { title: '基础档案', icon: 'icon-nav' },
  children: [
    {
      path: 'supplier',
      name: 'BaseSupplier',
      component: () => import('@/views/base/SupplierList.vue'),
      meta: { title: '供应商档案', permissions: ['base:supplier:view'] },
    },
    {
      path: 'customer',
      name: 'BaseCustomer',
      component: () => import('@/views/base/CustomerList.vue'),
      meta: { title: '客户档案', permissions: ['base:customer:view'] },
    },
    {
      path: 'item',
      name: 'BaseItem',
      component: () => import('@/views/base/ItemList.vue'),
      meta: { title: '存货物料', permissions: ['base:item:view'] },
    },
    {
      path: 'department',
      name: 'BaseDepartment',
      component: () => import('@/views/base/DepartmentList.vue'),
      meta: { title: '部门档案', permissions: ['base:department:view'] },
    },
    {
      path: 'user',
      name: 'BaseUser',
      component: () => import('@/views/base/UserList.vue'),
      meta: { title: '用户管理', permissions: ['base:user:view'] },
    },
    {
      path: 'employee',
      name: 'BaseEmployee',
      component: () => import('@/views/base/EmployeeList.vue'),
      meta: { title: '职员档案', permissions: ['base:employee:view'], hidden: true },
    },
    {
      path: 'warehouse',
      name: 'BaseWarehouse',
      component: () => import('@/views/base/WarehouseList.vue'),
      meta: { title: '仓库档案', permissions: ['base:warehouse:view'] },
    },
    {
      path: 'account',
      name: 'BaseAccount',
      component: () => import('@/views/base/AccountList.vue'),
      meta: { title: '会计科目', permissions: ['base:account:view'] },
    },
    {
      path: 'bank-account',
      name: 'BaseBankAccount',
      component: () => import('@/views/base/BankAccountList.vue'),
      meta: { title: '银行账户', permissions: ['base:bankaccount:view'] },
    },
  ],
}

export default baseRoutes
